module.exports = __webpack_public_path__ + "static/media/MierA-Bold.dd196b9b.ttf";